import { userAccountDetails } from "@biz-store/auth/feature.selectors";
import { createSelector } from "@ngrx/store";

export const SubdomainList = createSelector(userAccountDetails, (user) => user.ListTenantAccount);